<template>
    <div class="modal fade" :id="modalID" tabindex="-1" role="dialog" :aria-labelledby="titleID" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" :class="dialogClass" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="titleID">{{ name | capitalize }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div v-if="showfooter" class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jQuery from 'jquery';
import uuid from '../../library/uuid';

export default {
    props: {
        uuid: {
            default: true
        },
        name: {
            required: true
        },
        dialogClass: {
            default: null
        }
    },
    data() {
        return {
            main: null,
            myuuid: this.uuid ? uuid() : null
        };
    },
    mounted() {
        let component = this;
        jQuery(this.$el).on('shown.bs.modal', function () {
            this.toggleAttribute('tabIndex', false);
        });
        jQuery(this.$el).on('hidden.bs.modal', function () {
            this.setAttribute('tabIndex', -1);
        });
    },
    computed: {
        modalID() {
            return this.name + (this.uuid ? '-' + this.myuuid : '')
        },
        titleID() {
            return this.name + (this.uuid ? '-Title-' + this.myuuid : '')
        },
        showfooter() {
            return !!this.$slots.footer;
        }
    },
    filters: {
        capitalize(value) {
            if (!value) return;
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    methods: {
        modalShow() {
            jQuery(this.$el).modal('show');
        },
        modalHide() {
            jQuery(this.$el).modal('hide');
        }
    }
}
</script>
